import React from "react";

import "../../tokens/tokens.css";
import "./index.css";

/**
 * V2EmptyState — centered card for "nothing to show" and error states:
 * an optional icon, a title, an optional message and an optional action.
 */
export default function V2EmptyState({ icon, title, message, action, className = "" }) {
  return (
    <div className={`v2-empty-state ${className}`.trim()}>
      {icon && <div className="v2-empty-state-icon">{icon}</div>}
      <p className="v2-empty-state-title">{title}</p>
      {message && <p className="v2-empty-state-message">{message}</p>}
      {action && <div className="v2-empty-state-action">{action}</div>}
    </div>
  );
}
